import classnames from 'classnames';
import React, { forwardRef } from 'react';

/**
 * Dialog is the outermost element, which controls visibility
 * @param props DialogProps
 */ const Dialog = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, className, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement("div", {
        ...otherProps,
        className: classnames({
            'bf-dialog': true,
            [`${className}`]: !!className
        }),
        ref: ref,
        role: "presentation"
    }, children);
});

export { Dialog };
//# sourceMappingURL=dialog.js.map
